import { Box, PageBlock } from 'braid-design-system';

import { useHeroVariant } from 'src/hooks/use-hero-variant';
import {
  useAccountContext,
  useDashboardJobs,
  useDashboardTalentSearch,
} from 'src/modules/ApiClient';

import { ExistingHirerHero } from './ExistingHirerHero';
import { NewHirerHero } from './NewHirerHero';
import { PTSHirerHero } from './PTSHirerHero';
import { BlueDonutSvg } from './SVGs/BlueDonutSvg';

import * as styles from './Hero.css';

export interface HeroContentProps {
  firstName: string;
  hasCreateJobsPermission: boolean;
}

export const Hero = () => {
  const { data: accountContext } = useAccountContext();
  const { data: jobsInfo } = useDashboardJobs();
  const { data: hirerDashboardTalentSearch } = useDashboardTalentSearch();
  const modeToShow = useHeroVariant();

  if (!accountContext || !jobsInfo || !hirerDashboardTalentSearch) {
    return null;
  }

  const firstName = `${accountContext.user?.name} |`.split(' ')[0];
  const hasCreateJobsPermission =
    accountContext.currentAdvertiser.permissionOptions.canCreateJobs;

  const content = {
    NewHirer: (
      <NewHirerHero
        firstName={firstName}
        hasCreateJobsPermission={hasCreateJobsPermission}
      />
    ),
    ExistingHirer: (
      <ExistingHirerHero
        firstName={firstName}
        hasCreateJobsPermission={hasCreateJobsPermission}
      />
    ),
    PTSHirer: (
      <PTSHirerHero
        firstName={firstName}
        hasCreateJobsPermission={hasCreateJobsPermission}
      />
    ),
  }[modeToShow];

  return (
    <Box position="relative" className={styles.heroBanner} paddingY="xlarge">
      <PageBlock width="large">{content}</PageBlock>
      {modeToShow !== 'NewHirer' ? (
        <Box className={styles.svgContainer}>
          <BlueDonutSvg />
        </Box>
      ) : null}
    </Box>
  );
};
